import { FC, useState } from 'react'
import { Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import DropdownMenuItemsGrid from '@/components/organisms/filter/dropdownMenuItemsGrid'
import useTranslation from 'next-translate/useTranslation'
import FormInput from '@/components/molecules/form/formInput'
import DropDownGridItem, { DropwDownGridItemSection } from './dropDownGridItem'
import { ActiveFiltersBox } from '@/components/molecules/filter'
import { FilterSection } from '@/network/graphql.g'

type ManufacturerDesktopFilterProps = {
  manufacturers: FilterSection[]
  onManufacturerChange: (id: string, englishName: string) => void
  isInActiveFilters?: (id: string) => boolean
  namesForActiveManufacturerFilters?: string[]
  onDiscardFilters?: () => void
}

enum sortBoostManufacturers {
  topPosition = 'product.manufacturer_top_brands',
  bottomPosition = 'product.manufacturer_another_brands'
}

const ManufacturerDesktopFilter: FC<ManufacturerDesktopFilterProps> = ({
  manufacturers,
  onManufacturerChange,
  isInActiveFilters,
  namesForActiveManufacturerFilters,
  onDiscardFilters
}) => {
  const { t } = useTranslation('common')
  const [searchText, setSearchText] = useState<string>('')
  const filteredManufacturers = (): DropwDownGridItemSection[] => {
    const finalManufacturers =
      searchText.length === 0
        ? manufacturers
        : manufacturers.map(({ title, items }) => ({
            title,
            items: items.filter(({ title }) =>
              title.toLowerCase().includes(searchText.toLowerCase())
            )
          }))
    return finalManufacturers
      .map(({ id, title, items }) => ({
        id,
        title,
        items: items.map(({ id, title, count, englishName }) => ({
          id,
          title,
          count,
          isSelected: isInActiveFilters ? isInActiveFilters(id) : false,
          onSelect: () =>
            onManufacturerChange && onManufacturerChange(id, englishName)
        }))
      }))
      .sort((a, b) =>
        a.id === sortBoostManufacturers.topPosition
          ? -1
          : b.id === sortBoostManufacturers.bottomPosition
          ? 1
          : 0
      )
  }

  return (
    <Flex flexDirection="column">
      <SearchInput
        value={searchText}
        placeholder={t('Category.Filter.manufacturerSearchPlaceholder')}
        onChange={(name, value) => setSearchText(value)}
        data-cy="searchInputManufacturer"
      />
      <DropdownMenuItemsGrid>
        {namesForActiveManufacturerFilters &&
          namesForActiveManufacturerFilters.length > 0 && (
            <ActiveFiltersBox
              items={namesForActiveManufacturerFilters}
              onDiscard={onDiscardFilters}
            />
          )}
        <DropDownGridItem
          key={'manufacturers+grid'}
          sections={filteredManufacturers()}
        />
      </DropdownMenuItemsGrid>
    </Flex>
  )
}

export default ManufacturerDesktopFilter

const SearchInput = styled(FormInput)`
  margin-bottom: 10px;
  margin-left: -10px;
`
